import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import JSConfetti from 'js-confetti';
import { FormattedMessage } from 'react-intl';

import MysteryRevealCard from 'Components/Order/KeyReveals/MysteryRevealCard';

import 'Components/Order/KeyReveals/GiftBox/GiftBoxReveal.scss';
import 'Components/Order/KeyReveals/GiftBox/GiftBox3D.scss';

export default function GiftBoxReveal({
  uniqueId,
  item,
  viewKeys,
  testReveal,
  testGame,
}) {
  const [revealed, setRevealed] = useState(false);
  const [canvas, setCanvas] = useState(null);
  const [zIndexGift, setZindexGift] = useState(false);
  const [showText, setShowText] = useState(false);

  const canvasRef = useRef(canvas);

  const openTheGift = useCallback(() => {
    const jsConfetti = new JSConfetti({ canvas });
    // Check canvas exists
    if (canvasRef.current === canvas) {
      jsConfetti.addConfetti({
        confettiColors: [
          '#ff6600',
          '#d1631f',
          '#fdd756',
          '#ff9720',
          '#f2d4cd',
          '#000000',
          '#ffffff',
        ],
      });
    }

    window.setTimeout(() => {
      setZindexGift(true);
    }, 1250);

    window.setTimeout(() => {
      setShowText(true);
    }, 2500);

    return setRevealed(true);
  }, [canvas]);

  useEffect(() => {
    canvasRef.current = document.getElementById(`confetti-present-canvas-${uniqueId}`);
    setCanvas(canvasRef.current);
    setTimeout(() => { openTheGift(); }, 1500);
  }, [openTheGift, canvas, setCanvas, uniqueId]);

  return (
    <>
      <div className="GiftBoxReveal">

        <div className={classNames('present', { 'present--open': revealed }, { 'present--forward': zIndexGift })}>
          <div className="present__lid">
            <div className="present__lid__parts">
              <div className="present__lid__parts__top">
                <div className="present__lid__parts__top__leftTape" />
                <div className="present__lid__parts__top__rightTape" />
              </div>
              <div className="present__lid__parts__front">
                <div className="present__lid__parts__front__leftPanel">
                  <div className="present__tape" />
                </div>
                <div className="present__lid__parts__front__rightPanel">
                  <div className="present__tape" />
                </div>
              </div>
            </div>
            <div className="present__lid__shadow">
              <div className="present__lid__shadow__leftShadow" />
              <div className="present__lid__shadow__rightShadow" />
            </div>
          </div>

          <div className="present__box">
            <div className="present__box__front">
              <div className="present__box__front__leftPanel">
                <div className="present__tape" />
              </div>
              <div className="present__box__front__rightPanel">
                <div className="present__tape" />
              </div>
            </div>
            <div className="present__box__contents">
              <MysteryRevealCard
                soundOn={false}
                game={testReveal ? testGame : item}
              />
            </div>
            <div className="present__box__back">
              <div className="present__box__back__leftPanel" />
              <div className="present__box__back__rightPanel" />
            </div>
          </div>
        </div>

        {testReveal &&
          <div className={classNames('GiftBoxReveal__openText', { 'GiftBoxReveal__openText--visible': showText })}>
            <FormattedMessage id="gift-box-reveal.test-text" defaultMessage="Now you’ve tried it, get your gift and see what you find!" />
          </div>
        }

        {showText && !testReveal &&
          <button className="MysteryReveal__revealButton MysteryReveal__revealButton--birthday mt-4" onClick={() => { viewKeys(); }}>
            <FormattedMessage id="gift-box-reveal.button.view-key" defaultMessage="View your key" />
          </button>
        }
      </div>
      <canvas id={`confetti-present-canvas-${uniqueId}`} className="giftBoxCanvas" />
    </>
  );
}

GiftBoxReveal.propTypes = {
  item: PropTypes.shape({}),
  testGame: PropTypes.shape({}),
  viewKeys: PropTypes.func,
  testReveal: PropTypes.bool,
  uniqueId: PropTypes.string,
};

GiftBoxReveal.defaultProps = {
  item: {},
  testGame: {},
  viewKeys: () => {},
  testReveal: false,
  uniqueId: '',
};
